import { getRuntimeOptions } from '../NewCreditRequest/RequestConfiguration/util/getRuntimeOptions';
import { LOAN_REQUEST_CAR_TYPE, LOAN_REQUEST_CAR_FINANCING_WISH, LOAN_REQUEST_USAGE } from 'cpool-constants';

export const prepareSelectedRuntimeOption = ({
    carType,
    currentRuntime,
    carFinancingWish,
    usageType,
}: {
    carType: LOAN_REQUEST_CAR_TYPE | undefined;
    carFinancingWish: LOAN_REQUEST_CAR_FINANCING_WISH | undefined;
    currentRuntime: number | null;
    usageType: LOAN_REQUEST_USAGE | null;
}) => {
    if (currentRuntime === null) {
        return -1;
    }
    const runtimeOptions = getRuntimeOptions({ carType, carFinancingWish, usageType });
    const enabledOptions = runtimeOptions.filter((option) => !option.disabled);
    if (enabledOptions.length === 0) {
        return -1;
    }

    const isCurrentSelectable = enabledOptions.some((option) => option.value === currentRuntime);
    if (isCurrentSelectable) {
        return -1;
    }

    const closestOption = enabledOptions.reduce((closest, option) =>
        Math.abs(option.value - currentRuntime) < Math.abs(closest.value - currentRuntime) ? option : closest,
    );
    return closestOption.value;
};
